var symphony = symphony || {};

symphony.nav = {
    closeAll: function () {
        var mainNav = document.querySelector('.flyoutNav-root');
        if (mainNav) {
            mainNav.classList.add('closingMenus');
        }

        setTimeout(function () {
            var viewingChildElms = document.querySelectorAll('.viewingChild');
            for (var i = 0; i < viewingChildElms.length; i++) {
                var elm = viewingChildElms[i];
                elm.classList.remove('viewingChild');
            }

            setTimeout(function () {
                if (mainNav) {
                    mainNav.classList.remove('closingMenus');
                }
            }, 300);
        }, 100);
    },

    // for sym 2016 theme
    toggleChild: function (e, elm) {
        e = e || window.event;
        e.preventDefault();
        e.stopPropagation();
        
        if (elm.parentElement.classList.contains('viewingChild')) {
            elm.parentElement.classList.remove('viewingChild');
         } else {
        elm.parentElement.classList.add('viewingChild');
    }
    },

    // for kroc theme
    registerControls: function () {
        $('.flyoutNav-root > li.hasChildren').on('mouseover', function () {
            if ($(window).width() >= 800) {
                // reset left margin
                $(this).find('ul').eq(0).css('marginLeft', 0);

                if ($(this).find('ul').eq(0).offset().left < 0) {
                    // if it's off the left side of the screen push it to the right
                    $(this).find('ul').eq(0).css('marginLeft', Math.abs($(this).find('ul').eq(0).offset().left));
                } else if ($(this).find('ul').eq(0).offset().left + $(this).find('ul').eq(0).outerWidth() > $(window).width()) {
                    // if it's off the right side of the screen pull it to the left
                    $(this).find('ul').eq(0).css('marginLeft', -($(this).find('ul').eq(0).offset().left + $(this).find('ul').eq(0).outerWidth() - $(window).width()));
                }
            }
        });

        var returnedFunction = UTIL.debounce(function () {
            $('.flyoutNav-root > li.hasChildren > ul').css('marginLeft', 0);
        }, 250);

        window.addEventListener('resize', returnedFunction);
    },
    goBack: function (elm) {
        elm.parentElement.parentElement.parentElement.classList.remove('viewingChild');
        elm.parentElement.parentElement.parentElement.parentElement.classList.remove('viewingChild');
    },
    
    viewChild: function (e, elm) {
        e = e || window.event;
        e.preventDefault();
        e.stopPropagation();
        elm.parentElement.classList.add('viewingChild');
    },
    viewChildHover: function (e, elm) {
        e = e || window.event;
        e.preventDefault();
        e.stopPropagation();
        elm.classList.add('viewingChild');
    },

    closeChild:function (e, elm) {
        e = e || window.event;
        e.preventDefault();
        e.stopPropagation();
        elm.classList.remove('viewingChild');
    }
};
